module.exports = ".containerSpinner {\n    position: relative;\n}\nspinner-component {\n    position: absolute;\n    top: -5px;\n    right: 12px;\n}\n\n#map {\n    height: 300px;\n    width: 100%;\n}\n\n.btnCoord {\n    margin-top: 20px;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/estruturas/enderecos/endereco-form/endereco-form.component.css
 ** module id = 901
 ** module chunks = 0
 **/